export default __webpack_public_path__ + "static/media/P10011.21c4c3d6.png";